import type React from 'react';
import { designTokens } from '@course-authoring/shared-types';
import type { BasicContentLayout } from '@course-authoring/shared-types';

interface BasicContentLayoutToggleProps {
  currentLayout: BasicContentLayout;
  onSelectLayout: (layout: BasicContentLayout) => void;
}

export function BasicContentLayoutToggle({
  currentLayout,
  onSelectLayout,
}: BasicContentLayoutToggleProps): React.ReactElement {
  const options: Array<{ value: BasicContentLayout; label: string }> = [
    { value: 'image-top', label: 'Image Top' },
    { value: 'image-left', label: 'Image Left' },
    { value: 'image-right', label: 'Image Right' },
    { value: 'no-image', label: 'No Image' },
  ];

  return (
    <div style={styles.container}>
      <span style={styles.label}>Layout:</span>
      <div style={styles.options}>
        {options.map((option) => (
          <button
            key={option.value}
            type="button"
            onClick={() => onSelectLayout(option.value)}
            style={{
              ...styles.button,
              ...(currentLayout === option.value ? styles.buttonActive : styles.buttonInactive),
            }}
            aria-pressed={currentLayout === option.value}
            title={option.label}
          >
            {option.label}
          </button>
        ))}
      </div>
    </div>
  );
}

const styles: Record<string, React.CSSProperties> = {
  container: {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    gap: '8px',
    marginBottom: '16px',
  },
  label: {
    fontSize: '12px',
    color: designTokens.colors.textSecondary,
    fontWeight: designTokens.typography.fontWeight.semibold,
    letterSpacing: '0.05em',
    textTransform: 'uppercase',
  },
  options: {
    display: 'flex',
    alignItems: 'center',
    gap: '6px',
  },
  button: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '6px 10px',
    backgroundColor: '#fff',
    borderRadius: designTokens.borders.blockRadius,
    cursor: 'pointer',
    fontSize: designTokens.typography.fontSize.sm,
    fontWeight: designTokens.typography.fontWeight.medium,
    transition: designTokens.transitions.default,
    minWidth: '88px',
  },
  buttonActive: {
    border: `1px solid ${designTokens.colors.selectionBorder}`,
    backgroundColor: designTokens.colors.selectionBorder,
    color: '#fff',
  },
  buttonInactive: {
    border: `1px solid ${designTokens.colors.textMuted}`,
    backgroundColor: '#fff',
    color: designTokens.colors.textSecondary,
  },
};
